// components/ui/Badge.jsx
import React from "react";
import clsx from "clsx";

const VARIANTS = {
  // Rose -> Orange (défaut)
  new: {
    bg: "bg-gradient-to-r from-rose-500 to-orange-500",
    text: "text-white",
    ring: "ring-1 ring-white/20",
    shadow: "shadow-lg",
  },
  // Jaune -> Vert (style "nouveau")
  primary: {
    bg: "bg-gradient-to-br from-[#FFD54A] via-[#CDEB7A] to-[#63C66A]",
    text: "text-[#1F2937]",
    ring: "ring-1 ring-white/50",
    shadow: "shadow-[0_6px_16px_rgba(99,198,106,0.28)]",
  },
  // Mint (featured)
  featured: {
    bg: "bg-gradient-to-br from-[#18B9AE] via-[#14A59E] to-[#109F97]",
    text: "text-white",
    ring: "ring-1 ring-white/40",
    shadow: "shadow-[0_6px_16px_rgba(16,159,151,0.30)]",
  },
};

export default function Badge({
  children,
  variant = "new",
  animated = true,
  className,
  ...rest
}) {
  const v = VARIANTS[variant] || VARIANTS.new;

  return (
    <span
      className={clsx(
        "absolute -top-1  select-none",
        "px-3 py-1.5 rounded-full text-xs font-bold leading-none",
        v.bg,
        v.text,
        v.ring,
        v.shadow,
        "relative after:absolute after:inset-px after:rounded-full after:bg-white/10 after:mix-blend-overlay pointer-events-none",
        animated && "animate-[bounce_1.4s_ease-in-out_infinite]",
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
